import { useState, useEffect } from "react";
import { fetchPublicSignupAvailable } from "../api/client";

/**
 * Consulta GET /public/signup: cadastro público ativo no servidor (flag + template).
 * Em erro de rede, available=false (não exibir link).
 */
export function usePublicSignupAvailability() {
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchPublicSignupAvailable().then((ok) => {
      if (!cancelled) {
        setAvailable(!!ok);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { loading, available };
}
